import React, { useEffect, useState } from "react";
import ReportLayout from "../components/ReportLayout";
import { DateField } from "../components/DateField";
import { SelectField } from "../components/SelectField";
import API_BASE_URL from "../utilities/ApiConfig";
import axios from "axios";

export default function TehsilRegistry() {
  const [form, setForm] = useState({
    fromDate: "",
    toDate: "",
    report: "",
    district: "",
    tehsil: "",
  });

  const [districts, setDistricts] = useState([]);
  const [tehsils, setTehsils] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/Master/get_District_Mas`)
      .then((res) => setDistricts(res.data.data));
  }, []);

  //   useEffect(() => {
  //     axios
  //       .get(`${API_BASE_URL}/Registration/getDeedNames?mode=ALL`)
  //       .then((res) => {
  //         setDeeds(res.data);
  //       });
  //   }, []);

  const handleChange = (field) => (e) =>
    setForm((f) => ({ ...f, [field]: e.target.value }));
  const handleDownload = () => console.log(form);

  return (
    <ReportLayout title="Tehsil Registry" onDownload={handleDownload}>
      <SelectField
        id="report"
        label="Report Type"
        value={form.report}
        onChange={handleChange("report")}
        options={[
          { value: "revenue", label: "Revenue Comparison" },
          { value: "documents", label: "Document Count" },
          { value: "top-deeds", label: "Top Deeds" },
        ]}
      />
      <DateField
        id="fromDate"
        label="From Date"
        value={form.fromDate}
        onChange={handleChange("fromDate")}
      />
      <DateField
        id="toDate"
        label="To Date"
        value={form.toDate}
        onChange={handleChange("toDate")}
      />
      <SelectField
        id="district"
        label="Select District"
        value={form.district}
        onChange={handleChange("district")}
        options={districts.map((d) => ({
          value: d.dcode,
          label: d.districtName,
        }))}
      />
      <SelectField
        id="tehsil"
        label="Select tehsil"
        value={form.tehsil}
        onChange={handleChange("tehsil")}
        options={[
          { value: "tehsil1", label: "tehsil 1" },
          { value: "tehsil2", label: "tehsil 2" },
        ]}
      />
    </ReportLayout>
  );
}
